import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';

const Button = styled(LoadingButton)(() => ({
  height: '40px',
}));

export default Button;
